module.exports = function() {
  return new Worker(__webpack_public_path__ + "020f878e27ec8ba0ca6c.worker.js");
};